export enum PermissionEnum {
  Translation = 1,
  AddingSection = 2,
  EditingOrders = 3,
  GeneratingValuation = 4,
  CreateComplaintOrder = 9,
}
